import Vue from 'vue'
import App from './App.vue'
import router from "./router";
// 引入axios的封装文件
import {post} from '@/api/http';
Vue.config.productionTip = false
Vue.prototype.$post = post;

// 引入iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

// let protocol=window.location.protocol; (把https://强转成http://)
// if(protocol==='https:'){
//   window.location.href = 'http:'+ (window.location.href.substring(6))
// } 
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
